import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
export default React.memo(function RangeInput({ label, unit = '%', value = 50, min = 0, max = 100, step = 1, height = 32, onChange, onBlur, onMouseUp, className = '' }) {
    const percent = 100 * (value - min) / (max - min);
    return (_jsxs(Container, { className: `${className || ''} ui-range-input`, children: [label && _jsx(Label, { children: label }), _jsx(Input, { className: className, type: "range", height: height, min: min, max: max, step: step, percent: percent, value: value, onMouseUp: onMouseUp, onChange: evt => onChange === null || onChange === void 0 ? void 0 : onChange(+evt.target.value), onBlur: onBlur }), label && _jsx(Value, { children: `${value}${unit}` })] }));
});
const Container = styled.div `
  position: relative;
  box-sizing: border-box;
  width: 100%;
`;
const Label = styled.div `
  position: absolute;
  top: 50%;
  left: 0.75rem;
  transform: translateY(-50%);
  font-size: 1rem;
`;
const Value = styled.div `
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  font-size: 1rem;
`;
const Input = styled('input') `
  appearance: none;
  box-sizing: border-box;
  width: 100%;

  ${props => props.height && css `
    height: ${props.height}${typeof props.height === 'number' && 'px'};
    border-radius: ${props.height}${typeof props.height === 'number' && 'px'};
  `}

  background-image: -webkit-gradient(linear, 0% 0%, 100% 0%, color-stop(${props => props.percent}%, var(--ui-accent-color)), color-stop(${props => props.percent}%, rgba(0, 0, 0, 0.15)));

  &:focus {
    outline: none;
  }

  &::-webkit-slider-thumb {
    margin-left: ${props => -0.25 + props.percent / 100 * 0.5}rem;
    -webkit-appearance: none;
    width: ${props => props.height}${props => typeof props.height === 'number' && 'px'};
    height: ${props => props.height}${props => typeof props.height === 'number' && 'px'};
    border-radius: 50%;
    background-size: cover;
    cursor: pointer;
    background: var(--accent-blue) no-repeat
      url("data:image/svg+xml;utf8,<svg width='25%' height='25%' viewBox='0 0 24 24' fill='green' xmlns='http://www.w3.org/2000/svg'><circle cx='50%' cy='50%' r='20%' fill='white' fill-opacity='0.87'/></svg>");
  }


  &::-moz-range-track {
    width: 100%;
    border-radius: 0.375rem;
    height: ${props => props.height}${props => typeof props.height === 'number' && 'px'};
    background-color: var(--input-background);
    outline: none;
  }
  &::-moz-range-thumb {
    -webkit-appearance: none;
    width: ${props => props.height}${props => typeof props.height === 'number' && 'px'};
    height: ${props => props.height}${props => typeof props.height === 'number' && 'px'};
    border-radius: 50%;
    background-size: cover;
    background: var(--accent-blue) no-repeat
      url("data:image/svg+xml;utf8,<svg width='20%' height='20%' viewBox='0 0 24 24' fill='green' xmlns='http://www.w3.org/2000/svg'><circle cx='50%' cy='50%' r='20%' fill='white' fill-opacity='0.87'/></svg>");
    cursor: pointer;
    outline: none;
  }
`;
